import React from "react";
import Artist1 from '../../assets/images/artist1.png'
import Artist2 from '../../assets/images/artist2.png'
import Artist3 from '../../assets/images/artist3.png'
import Artist4 from '../../assets/images/artist4.png'
import Artist5 from '../../assets/images/artist5.png'
import Artist6 from '../../assets/images/artist6.png'
import Artist7 from '../../assets/images/artist7.png'
import Artist8 from '../../assets/images/artist8.png'

function Artists() {

    return (
        <section className="artists-section main-padding section-margin">
            <div className="container-fluid p-0">
                <div className="heading text-center">
                    <h2>Featured Artists</h2>
                </div>
                <div className="artists-list">
                    <div className="row">
                        <div className="col-sm-6 col-lg-4 col-xl-3">
                            <div className="artists">
                                <a href="#">
                                    <div className="d-flex align-items-center">
                                        <div className="artists-image">
                                            <img src={Artist1} alt="" className="img-fluid" />
                                        </div>
                                        <div className="artists-data">
                                            <h4>Sara Ramirez</h4>
                                            <p>2542 NFTs</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 col-xl-3">
                            <div className="artists">
                                <a href="#" >
                                    <div className="d-flex align-items-center">
                                        <div className="artists-image">
                                            <img src={Artist2} alt="" className="img-fluid" />
                                        </div>
                                        <div className="artists-data">
                                            <h4>Sara Ramirez</h4>
                                            <p>2542 NFTs</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 col-xl-3">
                            <div className="artists">
                                <a href="#" >
                                    <div className="d-flex align-items-center">
                                        <div className="artists-image">
                                            <img src={Artist3} alt="" className="img-fluid" />
                                        </div>
                                        <div className="artists-data">
                                            <h4>Sara Ramirez</h4>
                                            <p>2542 NFTs</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 col-xl-3">
                            <div className="artists">
                                <a href="#" >
                                    <div className="d-flex align-items-center">
                                        <div className="artists-image">
                                            <img src={Artist4} alt="" className="img-fluid" />
                                        </div>
                                        <div className="artists-data">
                                            <h4>Sara Ramirez</h4>
                                            <p>2542 NFTs</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 col-xl-3">
                            <div className="artists">
                                <a href="#" >
                                    <div className="d-flex align-items-center">
                                        <div className="artists-image">
                                            <img src={Artist5} alt="" className="img-fluid" />
                                        </div>
                                        <div className="artists-data">
                                            <h4>Sara Ramirez</h4>
                                            <p>2542 NFTs</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 col-xl-3">
                            <div className="artists">
                                <a href="#" >
                                    <div className="d-flex align-items-center">
                                        <div className="artists-image">
                                            <img src={Artist6} alt="" className="img-fluid" />
                                        </div>
                                        <div className="artists-data">
                                            <h4>Sara Ramirez</h4>
                                            <p>2542 NFTs</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 col-xl-3">
                            <div className="artists">
                                <a href="#" >
                                    <div className="d-flex align-items-center">
                                        <div className="artists-image">
                                            <img src={Artist7} alt="" className="img-fluid" />
                                        </div>
                                        <div className="artists-data">
                                            <h4>Sara Ramirez</h4>
                                            <p>2542 NFTs</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 col-xl-3 ">
                            <div className="artists">
                                <a href="#" >
                                    <div className="d-flex align-items-center">
                                        <div className="artists-image">
                                            <img src={Artist8} alt="" className="img-fluid" />
                                        </div>
                                        <div className="artists-data">
                                            <h4>Sara Ramirez</h4>
                                            <p>2542 NFTs</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    )
}
export default Artists;